import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode } from "vue";

const _hoisted_1 = /*#__PURE__*/_createTextVNode("在校学生");

const _hoisted_2 = /*#__PURE__*/_createTextVNode("毕业生");

const _hoisted_3 = /*#__PURE__*/_createTextVNode("其他");

const _hoisted_4 = {
  class: "dialog-footer"
};

const _hoisted_5 = /*#__PURE__*/_createTextVNode("取消");

const _hoisted_6 = /*#__PURE__*/_createTextVNode("提交 ");

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_option = _resolveComponent("el-option");

  const _component_el_select = _resolveComponent("el-select");

  const _component_el_form_item = _resolveComponent("el-form-item");

  const _component_el_input = _resolveComponent("el-input");

  const _component_el_radio = _resolveComponent("el-radio");

  const _component_el_radio_group = _resolveComponent("el-radio-group");

  const _component_el_form = _resolveComponent("el-form");

  const _component_el_button = _resolveComponent("el-button");

  const _component_el_dialog = _resolveComponent("el-dialog");

  return _openBlock(), _createElementBlock("div", null, [_createVNode(_component_el_dialog, {
    modelValue: $data.dialogFormVisible,
    "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => $data.dialogFormVisible = $event),
    title: "站长申请",
    center: ""
  }, {
    footer: _withCtx(() => [_createElementVNode("span", _hoisted_4, [_createVNode(_component_el_button, {
      type: "info",
      text: "",
      bg: "",
      size: "large",
      onClick: $options.hideDialog
    }, {
      default: _withCtx(() => [_hoisted_5]),
      _: 1
    }, 8, ["onClick"]), _createVNode(_component_el_button, {
      color: "#FF8112",
      size: "large",
      style: {
        "color": "#FFFFFF"
      },
      loading: $data.loading,
      onClick: _cache[7] || (_cache[7] = $event => $options.submitForm(_ctx.ruleFormRef))
    }, {
      default: _withCtx(() => [_hoisted_6]),
      _: 1
    }, 8, ["loading"])])]),
    default: _withCtx(() => [_createVNode(_component_el_form, {
      ref: "ruleFormRef",
      model: $data.ruleForm,
      rules: $data.rules,
      size: "large",
      "status-icon": "",
      "label-width": "100px"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_form_item, {
        label: "所选区域",
        required: ""
      }, {
        default: _withCtx(() => [_createVNode(_component_el_form_item, {
          prop: "province"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_select, {
            modelValue: $data.ruleForm.province,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.ruleForm.province = $event),
            placeholder: "请选择",
            onChange: $options.provinceChange,
            style: {
              "width": "200px",
              "margin-right": "10px"
            }
          }, {
            default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.provinceList, (provinceInfo, index) => {
              return _openBlock(), _createBlock(_component_el_option, {
                label: provinceInfo.name,
                value: provinceInfo.name,
                key: index
              }, null, 8, ["label", "value"]);
            }), 128))]),
            _: 1
          }, 8, ["modelValue", "onChange"])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          prop: "city"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_select, {
            modelValue: $data.ruleForm.city,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => $data.ruleForm.city = $event),
            placeholder: "请选择",
            onChange: $options.cityChange,
            style: {
              "width": "200px",
              "margin-right": "10px"
            }
          }, {
            default: _withCtx(() => [$data.cityList.length ? (_openBlock(true), _createElementBlock(_Fragment, {
              key: 0
            }, _renderList($data.cityList, (cityInfo, index) => {
              return _openBlock(), _createBlock(_component_el_option, {
                label: cityInfo.name,
                value: cityInfo.name,
                key: index
              }, null, 8, ["label", "value"]);
            }), 128)) : _createCommentVNode("", true)]),
            _: 1
          }, 8, ["modelValue", "onChange"])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          prop: "district"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_select, {
            modelValue: $data.ruleForm.district,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => $data.ruleForm.district = $event),
            placeholder: "请选择",
            onChange: $options.districtChange,
            style: {
              "width": "200px",
              "margin-right": "10px"
            }
          }, {
            default: _withCtx(() => [$data.districtList.length ? (_openBlock(true), _createElementBlock(_Fragment, {
              key: 0
            }, _renderList($data.districtList, (districtInfo, index) => {
              return _openBlock(), _createBlock(_component_el_option, {
                label: districtInfo.name,
                value: districtInfo.name,
                key: index
              }, null, 8, ["label", "value"]);
            }), 128)) : _createCommentVNode("", true)]),
            _: 1
          }, 8, ["modelValue", "onChange"])]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_el_form_item, {
        label: "申请地区",
        required: "",
        prop: "address"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_input, {
          placeholder: "请填写您申请运营的学校全称-含校区名",
          modelValue: $data.ruleForm.address,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => $data.ruleForm.address = $event),
          style: {
            "width": "620px"
          }
        }, null, 8, ["modelValue"])]),
        _: 1
      }), _createVNode(_component_el_form_item, {
        label: "您的身份",
        required: "",
        prop: "identity"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_radio_group, {
          modelValue: $data.ruleForm.identity,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => $data.ruleForm.identity = $event)
        }, {
          default: _withCtx(() => [_createVNode(_component_el_radio, {
            label: 0
          }, {
            default: _withCtx(() => [_hoisted_1]),
            _: 1
          }), _createVNode(_component_el_radio, {
            label: 1
          }, {
            default: _withCtx(() => [_hoisted_2]),
            _: 1
          }), _createVNode(_component_el_radio, {
            label: 2
          }, {
            default: _withCtx(() => [_hoisted_3]),
            _: 1
          })]),
          _: 1
        }, 8, ["modelValue"])]),
        _: 1
      }), _createVNode(_component_el_form_item, {
        label: "联系方式",
        required: "",
        prop: "phone"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_input, {
          placeholder: "填写您的电话或手机号",
          modelValue: $data.ruleForm.phone,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => $data.ruleForm.phone = $event),
          style: {
            "width": "620px"
          }
        }, null, 8, ["modelValue"])]),
        _: 1
      }), _createVNode(_component_el_form_item, {
        label: "您的姓名",
        required: "",
        prop: "name"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_input, {
          placeholder: "填写您的姓名",
          modelValue: $data.ruleForm.name,
          "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => $data.ruleForm.name = $event),
          style: {
            "width": "620px"
          }
        }, null, 8, ["modelValue"])]),
        _: 1
      })]),
      _: 1
    }, 8, ["model", "rules"])]),
    _: 1
  }, 8, ["modelValue"])]);
}